/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_HelpInputs */

const en_byoa_help = /** @type {(inputs: Byoa_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You get an AI key from your provider's settings page. Open the keys page, create a new key, then paste it here.`)
};

const id_byoa_help = /** @type {(inputs: Byoa_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci AI didapat dari halaman pengaturan penyediamu. Buka halaman kunci, buat kunci baru, lalu tempel di sini.`)
};

/**
* | output |
* | --- |
* | "You get an AI key from your provider's settings page. Open the keys page, create a new key, then paste it here." |
*
* @param {Byoa_HelpInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_help = /** @type {((inputs?: Byoa_HelpInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_HelpInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_help(inputs)
	return en_byoa_help(inputs)
});